module.exports = __webpack_public_path__ + "static/product-family-productpage-extra extra-a1346df93e3ba2963613833989fa17c3.png";